import { BRAND } from "constants/brand";
import { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

import { Form } from "react-bootstrap";

import { CSSTransition } from "react-transition-group";
import { Ring } from "@uiball/loaders";
import useHome from "hooks/useHome";
import { readApiError } from "utils/apiError";
import { FormControlLabel, FormGroup, Switch } from "@mui/material";
import { fieldOf } from "utils/formField";

const EditAlert = (props) => {
    const form = useRef();
    const nodeRef = useRef();
    const { loading, updateAlertsContent } = useHome();

    const submitHandler = async (e) => {
        e.preventDefault();

        const alertData = new FormData();

        alertData.append("id", props.region.id);
        alertData.append("content", fieldOf(form.current, "content").value);
        alertData.append("active", fieldOf(form.current, "active").checked);
        const result = await updateAlertsContent(alertData);
        // The kill switch must never report a change that did not happen
        // (admin#70). On a failure the modal stays open with the API's reason.
        const failure = readApiError(result, "تعذّر حفظ التعديل");
        props.fetchNumbers();
        if (failure) {
            props.showMessage("error", "هناك خطأ", failure);
            return;
        }
        props.close();
        props.showMessage("success", "تم التعديل", "تم التعديل بنجاح");
    };

    return (
        <>
            <div className={`model ${props.show ? "model-show" : ""}`} onClick={props.close}>
                <CSSTransition
                    mountOnEnter
                    unmountOnExit
                    nodeRef={nodeRef}
                    in={props.show}
                    timeout={400}
                    classNames="show"
                >
                    <div className="addItem" ref={nodeRef} onClick={(e) => e.stopPropagation()}>
                        {loading ? (
                            <div className="loading-spinner center">
                                <Ring size={40} lineWeight={5} speed={2} color={BRAND} />
                            </div>
                        ) : null}
                        <div className="head center">
                            <h5>تعديل</h5>
                            <FontAwesomeIcon icon={faClose} onClick={props.close} />
                        </div>
                        <Form className="form" ref={form} onSubmit={submitHandler}>
                            <Form.Group className="mb-3" controlId="name">
                                <Form.Label>
                                    النص<span>*</span>
                                </Form.Label>
                                <Form.Control
                                    name="content"
                                    type="text"
                                    placeholder="ادخل النص"
                                    defaultValue={props.region?.content}
                                    required
                                />
                            </Form.Group>
                            <FormGroup style={{ marginBottom: "20px" }}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            name="active"
                                            defaultChecked={props.region?.active}
                                            color="warning"
                                            onChange={(e) => {}}
                                        />
                                    }
                                    label="تفعيل"
                                />
                            </FormGroup>
                            <div className="buttons">
                                <button className="cancel" onClick={props.close} type="button">
                                    إلغاء
                                </button>
                                <button className="button" type="submit">
                                    حفظ
                                </button>
                            </div>
                        </Form>
                    </div>
                </CSSTransition>
            </div>
        </>
    );
};
export default EditAlert;
